<!-- Main -->
<app-mrp-scrolltop></app-mrp-scrolltop>
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">
      <header>
        <h3>Contact Us</h3>
      </header>

      <p>Please contact us to inquire about:</p>
      <ul>
        <li>Schedule RRBootcamp event for your group</li>
        <li>Zoom topic request</li>
        <li>Questions</li>
      </ul>

      <!-- Success Message -->
      @if (submissionSuccess) {
      <div class="">
        <p class="font-bold">Message submitted, Thank You!</p>
        <button (click)="goToHome()" class="login-btn">
          Home
        </button>
      </div>
      }

      <!-- Submit Error Message -->
      @if (submissionError) {
      <div class="">
        <p class="font-bold">Submission failed. Please try again later.</p>
        <button (click)="goToHome()" class="login-btn">
          Dismiss
        </button>
      </div>
      }

      @if (!submissionSuccess) {
      <div class="contact-form-container">
      <form id="contactForm" [formGroup]="contactForm" method="post">
        <div class="row gtr-uniform">
          <div class="col-12 ">
            <input type="text" id="name" formControlName="name" class="form-control" placeholder="Name"
              [ngClass]="{ 'is-valid': (submitted || f.name.dirty) && !f.name.errors, 'is-invalid': (submitted || f.name.dirty) && f.name.errors }">
            @if (f.name.invalid && (f.name.dirty || f.name.touched)) {
            <div class="invalid-feedback d-block"></div>
            }
            @if (f.name.errors && f.name.errors['required']) {
            <div>Name is required.</div>
            }
          </div>
          <div class="col-12 ">
            <input type="text" id="subject" formControlName="subject" class="form-control" placeholder="Subject"
              [ngClass]="{ 'is-valid': (submitted || f.subject.dirty) && !f.subject.errors, 'is-invalid': (submitted || f.subject.dirty) && f.subject.errors }">
            @if (f.subject.invalid && (f.subject.dirty || f.subject.touched)) {
            <div class="invalid-feedback d-block">
              @if (f.subject.errors?.['required']) {
              <div>Subject is required.</div>
              }
            </div>
            }
          </div>
          <div class="col-12 ">
            <textarea id="question" formControlName="question" class="form-control" rows="5"
              placeholder="Question / Message"
              [ngClass]="{ 'is-valid': (submitted || f.question.dirty) && !f.question.errors, 'is-invalid': (submitted || f.question.dirty) && f.question.errors }"></textarea>
            @if (f.question.invalid && (f.question.dirty || f.question.touched)) {
            <div class="invalid-feedback d-block">
              @if (f.question.errors?.['required']) {
              <div>Question is required.</div>
              }
            </div>
            }
          </div>
          <div class="col-12 ">
            <input type="email" id="replyEmail" formControlName="replyEmail" class="form-control" placeholder="Email"
              [ngClass]="{ 'is-valid': (submitted || f.replyEmail.dirty) && !f.replyEmail.errors, 'is-invalid': (submitted || f.replyEmail.dirty) && f.replyEmail.errors }">
            @if (f.replyEmail.invalid && (f.replyEmail.dirty || f.replyEmail.touched)) {
            <div class="invalid-feedback d-block">
              @if (f.replyEmail.errors?.['required']) {
              <div>Email is required.</div>
              }
              @if (f.replyEmail.errors?.['email']) {
              <div>Invalid email format.</div>
              }
            </div>
            }
          </div>
          <div class="col-12 ">
            <button class="login-btn" (click)="onSubmit()">{{statusMSG}}
              @if (loading) {
              <span class="button-spinner"></span>
              }
            </button>
          </div>
        </div>
      </form>
      </div>
      }

    </div>
  </div>
</section>

<app-footer></app-footer>